import { FileRoutesByPath } from "@tanstack/react-router"

export type RouteKeyType =
  // Landing Routes
  | "LANDING"
  | "BORROW_LANDING"
  | "MUSD_LANDING"
  | "GROWTH_LANDING"
  | "FAQ_LANDING"
  | "ABOUT"
  | "REWARDS"
  | "TERMS"
  | "PRIVACY"
  // Dapp Routes
  | "OVERVIEW"
  | "BORROW"
  | "MARKET"
  | "MARKET_ITEM"
  | "EARN"
  | "SWAP"
  | "VAULT"
  | "EXPLORE"

export const routes: Record<RouteKeyType, keyof FileRoutesByPath> = {
  // Landing Routes
  LANDING: "/",
  BORROW_LANDING: "/feature/borrow",
  MUSD_LANDING: "/feature/musd",
  GROWTH_LANDING: "/vaultcamp",
  FAQ_LANDING: "/faq",
  ABOUT: "/about",
  REWARDS: "/rewards",
  TERMS: "/terms",
  PRIVACY: "/privacy",
  // Dapp Routes
  OVERVIEW: "/overview",
  BORROW: "/borrow",
  // @ts-expect-error route is mapped to '/market/', but we need it without the slash at the end
  MARKET: "/market",
  MARKET_ITEM: "/market/items/$marketItemId",
  EARN: "/earn",
  SWAP: "/swap",
  VAULT: "/vault",
  EXPLORE: "/explore",
}
